import type { Page } from "$lib/def/api";

import { get$, post$, profile$, put$ } from "./core/auth";
import { catchError, firstValueFrom, map, switchMap, tap } from "rxjs";
import type { User } from "proto/user";
import type {Address} from "proto/address";

export interface VotingArea {
	latitude: string;
	longitude: string;
	street_name: string;
	province: string;
	postal_code: string;
	city: string;
	date: string;
	email: string;
	source: string;
	type: string;
	location: string;
}

export const MRD_TEL = '0873627600';

export function getWallet(limit = 25, offset = 0) {
	return profile$.pipe(
		switchMap(u => get$<WalletPage>(`api://v3/users/${u?.id}/wallet/refunds?limit=${limit}&offset=${offset}`))
	)
}

/**
 * Request a password reset email with a one time token.
 * @param email User email address
 * @returns A friendly message to display to the user.
 */
export function resetPassword(email: string) {
	return post$<{ friendly_message: string }>(`api://v3/users/passwordresetrequest`, { email })
}

// moved to payu.ts service file
// export function getCards() {
// 	return profile$.pipe(
// 		switchMap(user => get$<Payments>(`api://v3/users/${user?.id}/saved_cards?provider=all`))
// 	)
// }

export function voteForArea(body: VotingArea) {
	return profile$.pipe(
		// TODO: @Julian please add proper type here
		switchMap(user => post$<unknown>(`api://vote_for_area`, body)),
	)
}

export async function deleteAddress(label: string): Promise<Address> {
  const user = await firstValueFrom(profile$);

  if (user === null) return Promise.reject(new Error("Not logged in."));

  const validLabel = ["home", "work", "other"].includes(label);

  if (!validLabel) return Promise.reject(new Error(`Invalid label: ${label}.`));

  const saved_addresses = (user.saved_addresses ?? []);
  const address = saved_addresses.find(list => list.label === label);

  if (address === undefined) return Promise.reject(new Error(`No address labeled: ${label}.`));

  address.label = "_DELETE_ME_";

  const req$ = put$<User>(`api://v3/users/${user.id}`, { saved_addresses }).pipe(
    map(() => address),
    catchError((err) => {
      throw new Error(err?.error?.friendly_message || `Failed to delete address ${label}`, );
    })
  );
  return firstValueFrom(req$);
}

export type WalletPage = Page<Transaction> & { balance:number, payout_requested_at:string };

export interface Transaction {
	id: number;
	value: number;
	title: string;
	description: string;
	created_at: string;
	created_at_ts: number;
	type: 'debit' | 'credit';
	entity_type: 'transaction' | 'wallet';
	entity_id: string;
	balance: number;
	order_id: number;
	primary_payment_type: '' | 'instant_eft' | 'credit';
	from_compartment?: 'refunds' | 'reserved';
	to_compartment: 'payout' | 'refunds' | 'reserved';
	label: 'payout_request' | 'reserved' | 'early_credit' | 'voided';
}
